import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { formatApiDate } from '@/utils/format-date'

import {
  schoolYearFieldErrorsMapper,
  type SchoolYearFormPayload
} from '../constants/school-year-payload'

const useAddSchoolYear = ({
  onSuccess,
  onError
}: {
  onSuccess: ({ id }: { id: string }) => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (payload: SchoolYearFormPayload) =>
      httpService.panel.panelPeriodsYearsCreate({
        first_semester: {
          start_date: formatApiDate(payload.firstSemester.from),
          end_date: formatApiDate(payload.firstSemester.to)
        },
        second_semester: {
          start_date: formatApiDate(payload.secondSemester.from),
          end_date: formatApiDate(payload.secondSemester.to)
        }
      }),
    onSuccess: response => onSuccess({ id: response.id }),
    onError,
    fieldErrorsMapper: schoolYearFieldErrorsMapper
  })

export default useAddSchoolYear
